// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"7d74434e","216":"b00e628b","222":"7ff82f17","349":"14356425","406":"740d08cb","631":"0ea455bb","816":"976879ba","873":"66fc49a9","920":"f0e2eb38"}[chunkId] + ".chunk.js";
};